var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "305", persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "save-afiliation" },
        [
          _c(
            "v-layout",
            { attrs: { column: "" } },
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-close",
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("h1", [
                    _vm._v("¿Deseas guardar esta afiliación como en proceso?")
                  ]),
                  _c("v-spacer")
                ],
                1
              ),
              _c("v-card-text", { staticClass: "mt-2" }, [
                _c("p", { staticClass: "pb-3" }, [
                  _vm._v(
                    "Al guardarla como en proceso puedes continuar la afiliación en cualquier momento durante los próximos 7 días*."
                  )
                ]),
                _c("span", [
                  _vm._v("* El registro será desestimado después de 7 días.")
                ])
              ]),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "pt-0",
                      attrs: {
                        "align-center": "",
                        "justify-center": "",
                        column: "",
                        "fill-height": ""
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "primary-button mb-3",
                          attrs: { slot: "activator" },
                          on: { click: _vm.dontSaveData },
                          slot: "activator"
                        },
                        [_vm._v("Marcar como No concretada")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "primary-button mb-3",
                          on: { click: _vm.close }
                        },
                        [_vm._v("Guardar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-386c5c6b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-386c5c6b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/save-afiliation.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-386c5c6b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/save-afiliation.vue
// module chunks = 34